<template>
	<el-container class="home-container">
		<!-- 头部区 -->
		<el-header>
			<div>
				<img src="../assets/logo.png" alt="">
				<span>平安基地后台管理系统</span>
			</div>
			<el-button type="info" @click="onlineYuYue">在线预约</el-button>
			<el-button type="info" @click="logout">退出</el-button>
		</el-header>
		<!-- 页面主体区 -->
		<el-container>
			<!-- 侧边栏 -->
			<el-aside :width="isCollapse ? '64px' : '200px'">
				<div class="toggle-button" @click="toggleCollapse">|||</div>
				<!-- 侧边栏菜单区域 -->
				<el-menu background-color="#333744" text-color="#fff" active-text-color="#409EFF" :unique-opened="true"
					:collapse="isCollapse" :collapse-transition="false" :router="true" :default-active="activePath">
					<!-- 一级菜单 -->
					<el-submenu :index="item.id + ''" v-for="(item, index) in menulist" :key="index">
						<!-- 一级菜单的模板区域 -->
						<template slot="title">
							<!-- 图标 -->
							<i :class="iconsObj[item.id]"></i>
							<!-- 文本 -->
							<span>{{item.authName}}</span>
						</template>

						<!-- 二级菜单 -->
						<!-- @click='$route.path' -->
						<el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children" :key="subItem.id"
							@click="saveNavState('/' + subItem.path)">
							<template slot="title">
								<!-- 图标 -->
								<i :class="iconsObj[subItem.id]"></i>
								<!-- 文本 -->
								<span>{{subItem.authName}}</span>
							</template>
						</el-menu-item>
					</el-submenu>
				</el-menu>
			</el-aside>
			<!-- 右侧内容主体 -->
			<el-main background-color="#333744" text-color="#fff" active-text-color="#409EFF">
				<router-view></router-view>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				menulist: [],
				iconsObj: {
					125: 'iconfont icon-user',
					103: 'iconfont icon-tijikongjian',
					101: 'iconfont icon-user',
					102: 'iconfont icon-danju',
					105: 'iconfont icon-users',
					145: 'iconfont icon-baobiao',
					150: 'iconfont icon-tijikongjian',
					151: 'el-icon-menu',
					152: 'el-icon-menu',
					153: 'el-icon-menu',
					160: 'iconfont icon-tijikongjian',
					161: 'el-icon-menu',
					162: 'el-icon-menu',
					165: 'iconfont icon-tijikongjian',
					166: 'el-icon-menu',
					167: 'el-icon-menu',
					170: 'iconfont icon-tijikongjian',
					171: 'el-icon-menu',
					172: 'el-icon-menu',
					173: 'el-icon-menu',
					174: 'el-icon-menu',
					175: 'el-icon-menu',
					176: 'el-icon-menu',
					177: 'el-icon-menu',
					178: 'el-icon-menu',
					180: 'iconfont icon-tijikongjian',
					181: 'el-icon-menu',
					182: 'el-icon-menu',
					183: 'el-icon-menu',
					184: 'el-icon-menu',
					190: 'iconfont icon-tijikongjian',
					191: 'el-icon-menu',
					192: 'el-icon-menu',
					193: 'el-icon-menu',
					194: 'el-icon-menu',
					220: 'iconfont icon-tijikongjian',
					221: 'el-icon-menu',
					222: 'el-icon-menu',
					223: 'el-icon-menu',
					224: 'el-icon-menu',
					225: 'el-icon-menu',
					226: 'el-icon-menu',
					230: 'iconfont icon-tijikongjian',
					231: 'el-icon-menu',
					232: 'el-icon-menu',
					233: 'el-icon-menu',
					234: 'el-icon-menu',
					235: 'el-icon-menu',
					236: 'el-icon-menu',
					240: 'iconfont icon-tijikongjian',
					241: 'el-icon-menu',
					242: 'el-icon-menu',
					243: 'el-icon-menu',
					244: 'el-icon-menu',
					245: 'el-icon-menu',
					246: 'el-icon-menu',
					247: 'el-icon-menu',
					248: 'el-icon-menu',
					250: 'iconfont icon-tijikongjian',
					251: 'el-icon-menu',
					252: 'el-icon-menu',
					260: 'iconfont icon-tijikongjian',
					261: 'el-icon-menu',
					262: 'el-icon-menu',
				},
				isCollapse: false,
				activePath: ''
			}
		},
		created() {
			this.getMenuList()
			this.activePath = window.sessionStorage.getItem('activePath')
		},
		methods: {
			logout() {
				window.sessionStorage.clear()
				this.$router.push('/login')
			},
			onlineYuYue() {
				window.open('http://gw.safe-union.com')
			},
			async getMenuList() {
				const {
					data: res
				} = await this.$http.get('http://localhost:4000/menus')
				// if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
				this.menulist = res.menus
				console.log(res.menus)
			},
			toggleCollapse() {
				this.isCollapse = !this.isCollapse
			},
			saveNavState(activePath) {
				window.sessionStorage.setItem('activePath', activePath)
				this.activePath = activePath
			}
		}
	}
</script>

<style lang="less" scoped>
	.home-container {
		height: 100%;
	}

	.el-header {
		background-color: #373d41;
		display: flex;
		justify-content: space-between;
		padding-left: 0;
		align-items: center;
		color: #fff;
		font-size: 20px;

		>div {
			display: flex;
			align-items: center;
			span {
				margin-left: 15px;
			}
		}
	}

	.el-aside {
		background-color: #333744;

		.el-menu {
			border-right: none;
		}
	}

	.el-main {
		background-color: #eaedf1;
	}

	.iconfont {
		margin-right: 10px;
	}

	.toggle-button {
		background-color: #4a5064;
		font-size: 10px;
		line-height: 24px;
		color: #fff;
		text-align: center;
		letter-spacing: 0.2em;
		cursor: pointer;
	}

	img {
		width: 12%;
		margin-left: 5%;
	}
</style>
